import React from 'react'
import { StyledArticleSummaryWrapper } from './ArticleSummary.styled'

interface ArticlesSummaryProps {}
const ArticleSummary: React.FC<ArticlesSummaryProps> = ({ children }) => {
    return <StyledArticleSummaryWrapper>{children}</StyledArticleSummaryWrapper>
}

export default ArticleSummary
